import { render } from "./ActGoal5.vue?vue&type=template&id=6fc52f12"
import script from "./ActGoal5.vue?vue&type=script&lang=js"
export * from "./ActGoal5.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__